<template>
  <!-- вариант с перекрашиванием ответного коммента <div class="message" :class="message.destination_id ? 'replied-message' : ''"> -->
  <div class="message" :class="message.destination_id ? 'replied-message' : ''">
    <div class="message__inner">
      <div class="message__menu" :class="message.isControlsActive ? 'active' : ''" @click.stop="toggleControls" v-if="currentUser.id === message.owner_id">
        <svg width="23" height="4" viewBox="0 0 23 4" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="3" cy="2" r="2" fill="currentColor"/>
          <circle cx="11" cy="2" r="2" fill="currentColor"/>
          <circle cx="19" cy="2" r="2" fill="currentColor"/>
        </svg>
        <transition name="fade">
          <div class="message__popup" v-if="message.isControlsActive">
            <AppPopupMenu :items="{ pin: false, update: true, reply: false, quote: false, task: false, remove: true }"
                          @update-item="updateMessage"
                          @remove-item="removeMessage"
            />
          </div>
        </transition>
      </div>
      <div class="message__head">
        <div class="message__author">
          <div class="user-avatar message__avatar">
            <img v-if="message.owner.avatar !== null && message.owner.avatar .file_size"
                 :src="message.owner.avatar.url" alt="">
            <img v-else src="/img/avatar-thumb.png" alt="">
          </div>
          <div class="message__author-name">{{ message.owner.profile.name }} {{ message.owner.profile.surname }}</div>
        </div>

        <div class="message__date">
          {{ formatDateTime(message.created_at) }}
        </div>
      </div>
      <div class="message__reply">
        <div class="reply-to" v-if="message.destination_id">{{ message.destination.profile.name }} {{ message.destination.profile.surname }}</div>
        <div class="message__quote" v-if="message.quote">
          "{{ message.quote }}"
        </div>
      </div>
      <div class="message__body">
        <div class="message__text" @click.stop>
          <span class="plain-html" v-html="message.text"></span>
        </div>
      </div>
      <div class="message__attachment-preview" v-if="message.files || message.tags">
        <AppMessageAttachmentPreview :files="message.files && message.files.length !== 0 ? message.files : []"
                                     :tags="message.tags && message.tags.length !== 0 ? message.tags : []"
                                     :clickable="true"
        />
      </div>
    </div>
    <div class="message__bottom">
      <div class="reply-button" @click.stop="replyMessage">
        Ответить
        <span class="reply-button__icon">
          <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.07366 9.58256L2.55155 9.7296L2.62654 9.48589L2.47331 9.28208L2.07366 9.58256ZM3.77329 11.0602L4.01508 10.6226L3.8112 10.5099L3.5938 10.5935L3.77329 11.0602ZM1.32983 12L0.851944 11.853L0.549523 12.8358L1.50932 12.4667L1.32983 12ZM0.5 6.36286C0.5 7.68312 0.936992 8.90274 1.67402 9.88303L2.47331 9.28208C1.86206 8.46908 1.5 7.45898 1.5 6.36286H0.5ZM6.36286 0.5C3.12489 0.5 0.5 3.12489 0.5 6.36286H1.5C1.5 3.67718 3.67718 1.5 6.36286 1.5V0.5ZM12.2257 6.36286C12.2257 3.12489 9.60084 0.5 6.36286 0.5V1.5C9.04855 1.5 11.2257 3.67718 11.2257 6.36286H12.2257ZM6.36286 12.2257C9.60084 12.2257 12.2257 9.60084 12.2257 6.36286H11.2257C11.2257 9.04855 9.04855 11.2257 6.36286 11.2257V12.2257ZM3.5315 11.4979C4.37134 11.9618 5.33704 12.2257 6.36286 12.2257V11.2257C5.51044 11.2257 4.71064 11.0068 4.01508 10.6226L3.5315 11.4979ZM3.5938 10.5935L1.15034 11.5333L1.50932 12.4667L3.95278 11.5269L3.5938 10.5935ZM1.80772 12.147L2.55155 9.7296L1.59577 9.43551L0.851944 11.853L1.80772 12.147Z" fill="currentColor"/>
          </svg>
        </span>
      </div>
      <div class="message__date-updated" v-if="message.created_at !== message.updated_at">
        (ред.) {{ formatDateTime(message.updated_at) }}
      </div>
    </div>
  </div>
</template>

<script>
import AppPopupMenu from '../popup/AppPopupMenu'
import AppMessageAttachmentPreview from '@/components/page/input/AppMessageAttachmentPreview'
import { formatDateTime } from '@/utils/utils'

export default {
  name: 'comment-message',
  components: { AppMessageAttachmentPreview, AppPopupMenu },
  props: {
    message: Object
  },
  computed: {
    currentUser () {
      return this.$store.getters.currentUser
    }
  },
  methods: {
    toggleControls () {
      this.$emit('toggle-controls', this.message.id)
    },
    updateMessage () {
      this.$emit('update-message', this.message.id)
    },
    replyMessage () {
      const owner = this.message.owner
      const data = {
        userId: owner.id,
        userName: `${owner.profile.name}${owner.profile.surname ? ` ${owner.profile.surname}` : ''}`,
        quote: this.message.text
      }
      this.$emit('reply-message', data)
    },
    removeMessage () {
      this.$emit('remove-message', this.message.id)
    },
    formatDateTime (date) {
      return formatDateTime(date)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.message {
  @media screen and (max-width: $tablet_start) {
    font-size: 14px;
  }

  &__inner {
    position: relative;
    background: $color_main;
    color: $font_color_second;
    /* border: 1px solid $border_color; */
    border-radius: 3px;
    padding: 16px 80px 16px 20px;
    margin-bottom: 10px;

    @media screen and (max-width: $tablet_start) {
      padding: 14px;
      margin-bottom: 6px;
    }

    &:before {
      content: '';
      position: absolute;
      z-index: 2;
      top: 0;
      left: 0;
      width: 100%;
      height: 4px;
      border-radius: 3px 3px 0 0;
      background: $button_color_third;
    }
  }

  &__head {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    margin-bottom: 12px;

    @media screen and (max-width: $tablet_start) {
      flex-direction: column-reverse;
      align-items: flex-start;
    }
  }

  &__author {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    margin-right: 14px;

    @media screen and (max-width: $tablet_start) {
      margin-right: 0;
    }
  }

  &__author-name {
    color: $color-second-light;
  }

  &__date {
    @media screen and (max-width: $tablet_start) {
      margin-bottom: 8px;
    }
  }

  &__date-updated {
    margin-left: auto;
  }

  &__reply {
    position: relative;
    margin-bottom: 16px;
    padding-left: 16px;

    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 3px;
      background: #FAC658;
    }
  }

  &__quote {
    font-size: .8em;
    font-weight: 300;
    font-style: italic;
    color: $font_color_second;
  }

  &__body {
    margin-bottom: 4px;
  }

  &__attachment-preview {
    margin-top: 16px;
  }

  &__avatar {
    @include size(34px);
    margin-right: 14px;

    @media screen and (max-width: $tablet_start) {
      @include size(28px);
    }
  }

  &__menu {
    height: 14px;
    position: absolute;
    top: 12px;
    left: auto;
    right: 20px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    color: #95A4C0;
    cursor: pointer;
    transition: .3s;

    &:hover {
      color: $color_second-light;
    }

    &.active {
      color: $color_second-light;
    }
  }

  &__popup {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: auto;
    right: calc(100% + 10px);
    z-index: 999;
  }

  &__bottom {
    font-size: 12px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    color: $font_color_second;
  }
}

.reply-to {
  color: $color_second-light;
}

.reply-button {
  transition: .3s;
  cursor: pointer;
  user-select: none;

  &:hover {
    color: $color_second-light;
  }
}

.replied-message {
  .message__inner {
    &:before {
      content: '';
      position: absolute;
      z-index: 2;
      top: 0;
      left: 0;
      width: 100%;
      height: 4px;
      border-radius: 3px 3px 0 0;
      background: $button_color;
    }
  }
}
</style>
